// removed by extract-text-webpack-plugin
module.exports = {"commentsWrap":"qempo_Comments_commentsWrap-3VMenJX","comments":"qempo_Comments_comments-345K13R","comment":"qempo_Comments_comment-38KmVPF","header":"qempo_Comments_header-3DQRsL0","purchases":"qempo_Comments_purchases-3xAGOQ2","user":"qempo_Comments_user-24FWAdZ","name":"qempo_Comments_name-6UWlC0u","text":"qempo_Comments_text-36BqztE"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/QuoteStep/components/Comments/Comments.scss
// module id = 1715
// module chunks = 0